<div class="slider-navigation general-container">
  <ion-button #prevButton class="navigation-button swipper-button-prev"
    [ngClass]="color==='gray'&&'navigation-button-gray'" (click)="clickButton('previous')">
    <ion-icon class="navigation-icon" [ngClass]="font?.size" slot="icon-only" name="chevron-back-outline"></ion-icon>
  </ion-button>
  <ion-button #nextButton class="navigation-button swipper-button-next"
    [ngClass]="color=='gray'&&'navigation-button-gray'" (click)="clickButton('next')">
    <ion-icon class="navigation-icon" [ngClass]="font?.size" slot="icon-only" name="chevron-forward-outline"></ion-icon>
  </ion-button>
</div>